import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getJockeyHistorySlice = createSlice({
    name: 'JockeyHistory',
    initialState: {
        data: [],
        statusdata: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchJockeyHistory.pending, (state, action) => {
                state.statusdata = STATUSES.LOADING;
            })
            .addCase(fetchJockeyHistory.fulfilled, (state, action) => {
                state.data = action.payload;
                state.statusdata = STATUSES.IDLE
            })
            .addCase(fetchJockeyHistory.rejected, (state, action) => {
                state.statusdata = STATUSES.ERROR;
            })
    }
});

export const { setJockeyHistory, setStatus } = getJockeyHistorySlice.actions;
export default getJockeyHistorySlice.reducer;

export const fetchJockeyHistory = createAsyncThunk('/JockeyHistoryget/fetch', async ({ 
    id ,
    StartDate,
    EndDate,
    Nationality,
    RaceCourse,
    GroundType,
    RaceKind,
    HorseKind,
    RaceType,
    TrackLength
 }) => {
    const token = Cookies.get("token");
    const baseUrl = getBaseUrl().replace(/\/+$/, "");
    const headers = {};
    if (token && token !== "undefined") {
        headers.Authorization = token;
        headers["x-xsrf-token"] = token;
    }
    const finalId = id?._id || id;
    const res = await axios.get(`${baseUrl}/JockeyHistoryV3/${finalId}?StartDate=${StartDate === undefined ? "" : StartDate}&EndDate=${EndDate === undefined ? "" : EndDate}&Nationality=${Nationality === undefined ? "" : Nationality}&RaceCourse=${RaceCourse === undefined ? "" : RaceCourse}&GroundType=${GroundType === undefined ? "" : GroundType}&RaceKind=${RaceKind === undefined ? "" : RaceKind}&HorseKind=${HorseKind === undefined ? "" : HorseKind }&RaceType=${RaceType=== undefined ? "" : RaceType}&TrackLength=${TrackLength === undefined ? "" : TrackLength}`, {
        headers
    });
    const JockeyHistoryData = res.data;
    return JockeyHistoryData.data;
})
